import { useBeam } from "@randajan/bifrost/client/react";
import { meBeam } from "../../../assets/beams/meBeam";
import { usePop } from "@randajan/jet-react/dom/modal";
import { useCallback } from "react";
import { CharacterWizard } from "./CharacterWizard";

import { IdentityForm } from '../_forms/IdentityForm/IdentityForm';
import { PinForm } from '../_forms/PinForm/PinForm';


export const useCharacterWizard = (onPass=()=>{}) => {
    const { data: profile } = useBeam(meBeam);

    const pop = usePop({ lock: true });

    return useCallback(async _=> {
        if (!profile) { return; }

        const missingList = [];

        if (!profile.alias && !profile.gameEventUsers?.length) { missingList.push(IdentityForm); }
        if (!profile.hasPin) { missingList.push(PinForm); }

        if (!missingList.length) {
            pop.down();
            onPass();
        } else {
            pop.up({
                children: <CharacterWizard profile={profile} forms={missingList}/>,
                onDown:(_, result)=>{
                    if (result) { onPass(); }
                }
            });
        }

    }, [profile, pop]);
}